import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingCropFertilizersOrganics, setFootprintingCropFertilizersOrganicsAdmin } from "services";

import { footprintingCropPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_CROP_FERTILIZERS_ORGANIC } from "consts";

import { FootprintingCropFertilizer } from "models";

export const useMutateFootprintingCropFertilizersOrganics = (
  farmId: string,
  cropId: string,
  year: number,
  payload: FootprintingCropFertilizer[],
  primaryDataId: string
) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? setFootprintingCropFertilizersOrganicsAdmin : setFootprintingCropFertilizersOrganics;

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_CROP_FERTILIZERS_ORGANIC, primaryDataId, isAdmin],
      mutationFn: () => queryFn(payload, primaryDataId),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_CROP_FERTILIZERS_ORGANIC, primaryDataId, isAdmin],
          ...footprintingCropPrimaryQueryKeys(primaryDataId, farmId, cropId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
